import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomTranslation from "@/hooks/useTranslation";
import { VaultItem } from "../Game/type";
import { showGlobalLoading } from "@/components/globalLoading";
import API from "@/api";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import useRouter from "@/hooks/useRouter";
import {
	clearUserInfo,
	getUserInfoMethod,
	postApiFinanceBalance,
	setAdminType,
	setSuperiorToken,
	setUserInfo,
} from "@/redux/reducers/authSlice";
import React, { useEffect, useState } from "react";
import { isDef } from "@/util/validate";
import { isEmpty } from "lodash";
import { SafeArea, Image, Toast, Dialog } from "antd-mobile";
import AvatarImage from "@/components/avatarImage";
import { CreditsVault } from "@/api/type";
import CustomLanguage from "@/components/customLanguage";

const VaultManage: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { showLoading, hideLoading } = showGlobalLoading();
	const { customNavigate } = useRouter();

	const [vaultList, setVaultList] = useState<VaultItem[]>([]);
	const { userInfo, nativeUser, loginState } = useSelector(
		(state: RootState) => state.auth
	);
	const { search } = useSelector((state: RootState) => state.initialization);
	const [nickname, setNickname] = useState(userInfo?.nickname ?? "");
	const isCredits = window.location.href.toLowerCase().includes(CreditsVault);

	const selectVault = async (item: VaultItem) => {
		if (item.isAdmin) {
			showLoading();
			try {
				const response: any = await API.members.getSuperiorAgent();
				if (response?.code === 0) {
					const { token, user } = response.content.data;
					await dispatch(setAdminType(true));
					await dispatch(setSuperiorToken(token));
					await dispatch(setUserInfo(user));
					await dispatch(postApiFinanceBalance({ itemTypes: [2] }));
					try {
						await API.finances.apiFinanceAgentHome();
						customNavigate("/home");
					} catch (error) {
						console.log("预加载home数据失败:", error);
						Toast.show({
							content: t("LoadDataFailed"),
							position: "top",
						});
					}
				}
			} catch (error) {
				console.log("getSuperiorAgent error: ", error);
			} finally {
				hideLoading();
			}
		} else {
			if (userInfo?.agentType === 0) {
				Toast.show({
					content: t("NotOpen"),
					position: "top",
				});
				return;
			}
			showLoading();
			try {
				await dispatch(setAdminType(false));
				await dispatch(postApiFinanceBalance({ itemTypes: [2] }));
				await API.finances.apiFinanceAgentHome();
				customNavigate("/home");
			} catch (error) {
				console.log("预加载home数据失败:", error);
				Toast.show({
					content: t("LoadDataFailed"),
					position: "top",
				});
			} finally {
				hideLoading();
			}
		}
	};

	const initVaultList = () => {
		if (!isDef(userInfo)) {
			setVaultList([]);
			return;
		}
		const { agentType, income } = userInfo;
		const query = new URLSearchParams(search);
		const list: VaultItem[] = [];
		// if (
		// 	agentType === 1 ||
		// 	query.get("a") === "1" ||
		// 	!isEmpty(income) ||
		// 	nativeUser?.is_master
		// )
		if (agentType === 1) {
			const { nickname, walletAddress } = userInfo;
			list.push({
				id: userInfo.id,
				name: nickname,
				balance: userInfo?.balance?.[2] ?? 0,
				addr: walletAddress,
				isAdmin: false,
			});
		}

		if (agentType === 0 && isEmpty(income)) {
			const { nickname, walletAddress } = userInfo;
			list.push({
				id: userInfo.id,
				name: nickname,
				balance: undefined,
				addr: walletAddress,
				isAdmin: false,
			});
		}

		if (!isEmpty(income)) {
			const { id, nickname, walletAddress, balance } = income;
			list.push({
				id: id,
				name: nickname,
				balance: balance[2],
				addr: walletAddress,
				isAdmin: true,
			});
		}
		setVaultList(list);
		if (isDef(nativeUser)) {
			setNickname(nativeUser.name);
		}
	};

	useEffect(() => {
		setNickname(userInfo?.nickname ?? "");
		initVaultList();
	}, [userInfo]);

	useEffect(() => {
		dispatch(getUserInfoMethod());
	}, []);

	useEffect(() => {
		dispatch(setAdminType(false));
		if (loginState) {
			dispatch(getUserInfoMethod());
			dispatch(postApiFinanceBalance({ itemTypes: [1] }));
		}
	}, [loginState]);

	// useEffect(() => {
	// 	const getUserInfo = async () => {
	// 		dispatch(setAdminType(false));
	// 		await dispatch(getUserInfoMethod());
	// 		if (loginState) {
	// 			dispatch(postApiFinanceBalance({ itemTypes: [2] }));
	// 		}
	// 	};
	// 	getUserInfo();
	// }, [loginState, dispatch]);

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		initVaultList();
	// 	}, 60);
	// }, [userInfo]);

	const logout = async () => {
		const confirm = await Dialog.confirm({
			content: t("LogoutAlertContent"),
			cancelText: t("Cancel"),
			confirmText: t("Confirm"),
		});
		if (confirm) {
			dispatch(clearUserInfo());
			customNavigate("/login", { replace: true });
		}
	};

	return (
		<div className="router-main">
			<SafeArea position="top" />
			<div
				style={{
					position: "fixed",
					zIndex: 1000,
					bottom: pxToRem(50),
					right: pxToRem(20),
				}}
			>
				<CustomLanguage
					key={"language"}
					style={{ bottom: pxToRem(40) }}
				/>
			</div>
			<header className={classes.wrap}>
				<div
					onClick={() => {
						if (!isCredits) {
							customNavigate("/game", { replace: true });
						}
					}}
					className={classes.app}
				>
					<Image
						src={require("@/assets/images/icons/logo_small.png")}
						width={pxToRem(32)}
					/>
					<h3>
						COIN
						<br />
						GAMING
					</h3>
				</div>
				<div
					onClick={() => {
						if (isCredits) {
							logout();
						}
					}}
					className={classes.user}
				>
					<AvatarImage width={24} height={24} />
					<span>{nickname}</span>
				</div>
			</header>
			<div className="router-view">
				<h2 className={classes.title}>{t("SelectVault")}</h2>
				<ul className={classes.vaultList}>
					{vaultList.map((item, index) => {
						return (
							<li
								key={index}
								style={{
									background: item.isAdmin
										? "linear-gradient(156deg, #161921 5.2%, #151D3B 97.46%)"
										: "linear-gradient(156deg, #15203F 5.2%, #28316A 97.46%)",
								}}
								onClick={(event) => {
									event.stopPropagation();
									if (isDef(item.balance)) selectVault(item);
								}}
							>
								<div className={classes.addr}>
									<span>{t("TreasuryBalance")}</span>
								</div>
								<div className={classes.owner}>
									<AvatarImage
										url={
											!item.isAdmin
												? ""
												: require("@/assets/images/icons/user.png")
										}
										width={14}
										height={14}
									/>
									<span>
										{item.isAdmin ? t("Admin") : t("Owner")}
									</span>
								</div>
								<div className={classes.balance}>
									{item.balance ?? t("Auditing")}
								</div>
								{item.isAdmin && (
									<div className="vaultInfo">
										<span>
											{t("Owner")}: {item.name}
										</span>
									</div>
								)}
							</li>
						);
					})}
				</ul>
			</div>

			{/*
			<ApplyCenterPopup.PopupComp
				visible={ApplyCenterPopup.visiblePopup}
				onClose={ApplyCenterPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyCenterPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<InvitationCode onVisiblePopup={ApplyCenterPopup.closePopup} />
			</ApplyCenterPopup.PopupComp>
			*/}
			<div
				style={{
					color: "#fff",
					padding: pxToRem(10),
					textAlign: "center",
					fontSize: pxToRem(10),
					paddingTop: pxToRem(10),
				}}
			>
				<span>V1.0.1</span>
			</div>
		</div>
	);
};

export default VaultManage;

const useStyles = createUseStyles({
	wrap: {
		padding: pxToRem(18),
		display: "flex",
		alignItems: "center",
		color: "#fff",
	},
	app: {
		color: "#FFFFFF",
		flex: 1,
		display: "flex",
		alignItems: "center",
		"& > h3": {
			marginLeft: pxToRem(5),
			fontSize: pxToRem(15),
			fontWeight: 700,
			lineHeight: pxToRem(18),
		},
	},
	user: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(36),
		minWidth: pxToRem(100),
		borderRadius: pxToRem(40),
		padding: `${pxToRem(6)} ${pxToRem(7)}`,
		backgroundColor: "#12141C",
		"& span": {
			color: "#FFFFFF",
			fontWeight: 500,
			fontSize: pxToRem(14),
			paddingLeft: pxToRem(8),
		},
	},
	title: {
		padding: `${pxToRem(14)} ${pxToRem(24)}`,
		fontSize: pxToRem(14),
		fontWeight: 700,
		color: "#FFFFFF",
	},
	vaultList: {
		padding: `0 ${pxToRem(20)}`,
		"& > li": {
			position: "relative",
			borderRadius: pxToRem(10),
			minHeight: pxToRem(100),
			fontSize: pxToRem(14),
			fontWeight: 500,
			color: "#fff",
			padding: `${pxToRem(12)} ${pxToRem(16)}`,
			border: "1px solid #353F63",

			"&~li": {
				marginTop: pxToRem(6),
			},

			"& .vaultInfo": {
				display: "flex",
				justifyContent: "end",
				color: "#FFFFFF66",
				fontSize: pxToRem(12),
				fontWeight: 500,
				fontFamily: "Noto Sans SC",
				lineHeight: pxToRem(14),
			},
		},
	},
	addr: {
		color: "#8FCAD8",
		fontWeight: 500,
		fontSize: pxToRem(12),
		textAlign: "center",
		fontFamily: "Noto Sans SC",
	},
	owner: {
		display: "flex",
		alignItems: "center",
		position: "absolute",
		right: pxToRem(16),
		top: pxToRem(12),
		"& span": {
			paddingLeft: pxToRem(6),
		},
	},
	balance: {
		color: "#FFFFFF",
		marginTop: pxToRem(15),
		fontWeight: 600,
		fontSize: pxToRem(24),
		textAlign: "center",
		lineHeight: pxToRem(36),
	},
});
